import { Skeleton } from '@/shared/ui/skeleton.tsx';
import { format } from 'date-fns';

const EventSuspense = () => {
  return (
    <Skeleton className="w-full z-20 bg-white flex items-center justify-start gap-4 border border-black rounded-xl overflow-hidden">
      <div className="w-20 md:w-1/6 aspect-square bg-black flex flex-col items-center justify-center gap-0 md:gap-1 text-white">
        <p className="font-poppins font-medium md:text-lg">{format(new Date(), "MMM")}</p>
        <p className="text-2xl md:text-4xl font-semibold font-header">{format(new Date(), "d")}</p>
      </div>
      <div className='flex flex-col gap-2 flex-1'>
        <Skeleton className='h-7 w-2/3'></Skeleton>
        <Skeleton className='h-5 w-2/3'></Skeleton>
      </div>
    </Skeleton>
  )
}

export default EventSuspense;
